import HBIcon from "@/components/HBIcon";
import { useLogin } from "@/components/LoginModal";
import { TrackerA, TrackerDiv } from "@/components/Tracker";
import { BuyVipDialog } from "@/components/Vip";
import { EVENT } from "@/constants/event";
import useAppStore from "@/context/store";
import { isGdMerged } from "@/utils/gaoding";
import { VIP_RIGHT_PAGE } from "@/utils/host";
import { useMemoizedFn } from "ahooks";
import classNames from "classnames";
import { useCallback, useMemo } from "react";
import { When } from "react-if";
import { goGdMerge } from "../GdMerge";
import { gaodingEditUrl } from "../GdMerge/shared";
import styles from "./index.module.less";

export default function MaterialFooter({ data: conf }) {
  const { user, vips } = useAppStore(({ user, vips }) => ({
    user,
    vips,
  }));
  const { login } = useLogin();
  const isVip = vips.length > 0;

  const data = useMemo(() => {
    return conf?.gdMergedConf;
  }, [conf]);

  const onBuy = useMemoizedFn((type, source_location) => {
    if (!user) {
      login({
        source_location: "底部商业化模块",
      });
      return;
    }
    if (isVip) {
      window.open(VIP_RIGHT_PAGE);
    } else {
      (BuyVipDialog as any).open({
        page: "vipDetail",
        isGdDialog: true,
        type,
        source_location: source_location + "_查看方案",
      });
    }
  });

  const onSearch = useCallback(() => {
    const event = new CustomEvent(EVENT.SEARCH_BAR_FOCUS, {
      detail: "searchMaterial",
    });
    window.dispatchEvent(event);
  }, []);

  return (
    <div className={classNames(styles.footer)}>
      <When condition={!isVip}>
        <div className={styles.banner}>
          <div className={styles.personal}>
            <div className={styles.info}>
              <div className={styles.title}>{data?.personalTitle}</div>
              <div className={styles.subtitle}>{data?.personalSubtitle}</div>
            </div>
            <div className={styles.action}>
              <div className={styles.price}>
                <span>{data?.personalPrice}</span>
                {data?.personalPriceUnit}
              </div>
              <TrackerDiv
                className={styles.button}
                onClick={() => onBuy("personal", "底部基础版VIP")}
                data-gd-click="resource_loc_click"
                data-gd-expose="resource_loc_expose"
                data-resource-type="文字链接"
                data-resource-id={data?.id}
                data-resource-title="底部个人VIP"
                data-content-source="底部"
              >
                <div className={styles.text}>{data?.personalButtonText}</div>
                <HBIcon className={styles.icon} type="ic_chevron_right" />
              </TrackerDiv>
            </div>
          </div>
          <div className={styles.enterprise}>
            <div className={styles.info}>
              <div className={styles.title}>{data?.companyTitle}</div>
              <div className={styles.subtitle}>{data?.companySubtitle}</div>
            </div>
            <div className={styles.action}>
              <div className={styles.price}>
                <span>{data?.companyPrice}</span>
                {data?.companyPriceUnit}
              </div>
              <div
                className={styles.button}
                onClick={() => onBuy("company", "底部团队版VIP")}
                data-gd-click="resource_loc_click"
                data-gd-expose="resource_loc_expose"
                data-resource-type="文字链接"
                data-resource-id={data?.id}
                data-resource-title="底部企业VIP"
                data-content-source="底部"
              >
                <div className={styles.text}>{data?.companyButtonText}</div>
                <HBIcon className={styles.icon} type="ic_chevron_right" />
              </div>
            </div>
          </div>
        </div>
        <TrackerA
          className={styles.more}
          href={`${gaodingEditUrl}/pricing?from=gdmaterial`}
          target="_blank"
          data-gd-click="resource_loc_click"
          data-gd-expose="resource_loc_expose"
          data-resource-type="文字链接"
          data-resource-id={data?.id}
          data-resource-title="了解花瓣素材会员"
          data-content-source="底部"
          onClick={(e) => {
            e.preventDefault();
            if (isGdMerged(user)) {
              window.open(`${gaodingEditUrl}/pricing?from=gdmaterial`);
            } else {
              goGdMerge({
                redirectUri: `${gaodingEditUrl}/pricing?from=gdmaterial`,
              });
            }
          }}
        >
          <div className={styles.text}>了解花瓣素材会员</div>
          <HBIcon className={styles.icon} type="ic_chevron_right" />
        </TrackerA>
      </When>
      <div className={styles.empty}>
        到底了，
        <span onClick={onSearch}>搜一搜</span>
        发现更多商用素材
      </div>
    </div>
  );
}
